<p-tag
  [value]="value()"
  [severity]="severity()"
  [rounded]="rounded()"
  [icon]="icon()"
  [styleClass]="styleClass()">
</p-tag>
